import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
})
export class CustomDialogComponent implements OnInit {
  @Input() type: 'success' | 'error' | 'warning' | 'info' = 'success';
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() buttonText: string = 'OK';
  @Input() showYesNo: boolean = false;
  @Input() yesText: string = 'Yes';
  @Input() noText: string = 'No';

  iconName = 'checkmark-outline';
  iconColor = '#4CAF50';
  buttonColor = 'success';

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    switch (this.type) {
      case 'success':
        this.iconName = 'checkmark-outline';
        this.iconColor = '#4CAF50';
        this.buttonColor = 'success';
        if (!this.title) this.title = 'Success';
        break;

      case 'error':
        this.iconName = 'close-outline';
        this.iconColor = '#F44336';
        this.buttonColor = 'danger';
        if (!this.title) this.title = 'Error';
        break;

      case 'warning':
        this.iconName = 'alert-outline';
        this.iconColor = '#FF9800';
        this.buttonColor = 'warning';
        if (!this.title) this.title = 'Warning';
        break;

      case 'info':
        this.iconName = 'information-circle-outline';
        this.iconColor = '#2196F3';
        this.buttonColor = 'primary';
        if (!this.title) this.title = 'Information';
        break;
    }
  }

  dismiss(action: 'yes' | 'no' | 'ok' | 'backdrop') {
    this.modalCtrl.dismiss({ action });
  }
}
